import { render, staticRenderFns } from "./DashboardInicial.vue?vue&type=template&id=c87b4376&"
import script from "./DashboardInicial.vue?vue&type=script&lang=js&"
export * from "./DashboardInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports